import { kitsFields } from "../fragments";

export default `
  ${kitsFields}
  
  query($userProductsIds: [String!]) {
    kits(userProductsIds: $userProductsIds) {
    kits{
      ...kitsFields
    }
}
  }
`;